import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#0f4efb',
        secondary: '#111111',
        accent: '#0f4efb',
        error: '#dc2626',
        success: '#16a34a',
        warning: '#d97706'
      }
    }
  }
})
